module.exports = __webpack_public_path__ + "static/img/logo.c7f00f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/logo.png
// module id = 4Aus
// module chunks = 14